<ng-container [formGroup]="fg">
  <label
    class="checkbox-label"
    [ngClass]="{'weight-normal-label': isWeightNormalLabel}"
    *ngIf="placeholder != undefined && showPlaceholder == true"
    appConfigSettingsParagraph
  >
    <mat-checkbox
      class="checkbox"
      matCheckbox
      [formControl]="control"
      [required]="isRequired"
      type="checkbox"
      (change)="OnChange($event)"
      color="primary"
    >
    </mat-checkbox>
    {{ placeholder | translate }}
  </label>
  <mat-error *ngIf="isAnyError" class="error-message">
    <ng-container *ngIf="control.errors?.message">
      {{ control.errors.message }}
    </ng-container>
    <ng-container *ngIf="control.errors?.required">
      {{ isRequiredMessage }}
    </ng-container>
  </mat-error>
</ng-container>
